<template>
  <div class="page-header align-items-start min-vh-screen mbr-legal">
    <span class="mask bg-white"></span>
    <header class="mbr-legal__bar">
      <button type="button" class="mbr-legal__back" :aria-label="$t('common.back')" @click="goBack()">
        <i class="material-icons-round" aria-hidden="true">chevron_left</i>
      </button>
      <h1 class="mbr-legal__title">{{ $t('legal.privacy_title') }}</h1>
      <span aria-hidden="true"></span>
    </header>
    <div class="container mbr-legal__page">
      <div v-if="isLoadDone || loadFailed" class="card-body p-0 text-page pb-90">
        <div v-if="isLoadDone">
          <div class="row" v-if="privacyPolicy">
            <div class="mbr-legal__html" v-html="privacyPolicy"></div>
          </div>
          <div class="row" v-else>
            <div class="text-title pb-3">Minty CRM Privacy Policy</div>
            <div class="text-content pb-3">
              Minty CRM ("We","Our",”Us”) takes your privacy seriously. This
              Privacy Policy describes how your Personal Data is collected,
              used, and shared when you visit our Site or make a purchase.
            </div>
            <div class="text-title pb-3">Minty CRM PDPA</div>
            <div class="text-content pb-3">
              Megasafe Technology Pte Ltd (Reg. No. 200503951K) and its
              subsidiaries (“Minty CRM”) recognizes its responsibilities in
              relation to the protection of the personal data collected, used,
              disclosed, processed, transferred or retained under the Personal
              Data Protection Act (“PDPA”). Personal data will be collected only
              for lawful and relevant purposes and protected from any
              unauthorized access, use and disclosure. Minty CRM takes
              reasonable steps to ensure that personal data held by it is
              accurate. Minty CRM may from time to time update this Privacy
              Policy to ensure it is consistent with our business requirements,
              industry trends and/or changes in legal or regulatory
              requirements. Subject to your rights at law, you agree to be bound
              by the prevailing terms of this Privacy Policy as updated from
              time to time on Minty CRM’s website. Any updates to the Privacy
              Policy will be effective 30 days following the date on which this
              Privacy Policy is updated and posted on our website.
            </div>
            <div class="text-title pb-3">Collection of Personal Data</div>
            <div class="text-content pb-3">
              Personal Data refers to information about you, from which you are
              identifiable, including but not limited to your name, address(es),
              email address, organisation name, recipient name(s), and phone
              number(s). Sharing of your Personal Data is completely voluntary.
              However, do note that we may not be able to provide some of our
              services or accept payments without the required information. The
              collection of your Personal Data will generally occur when you
              provide your personal data to merchants using Minty CRM
              (“merchants”), for the purpose of, but not limited to:<br />
              &emsp;Signing up of membership
            </div>
            <div class="text-title pb-3">
              Usage and Disclosure of Personal Data
            </div>
            <div class="text-content pb-3">
              We may use the Personal Data merchants have collected for the
              purpose of, but not limited to:<br />
              &emsp;- Analytics<br />
              &emsp;- To be contacted by Minty CRM or its clients via<br />
              <ul>
                <li>Email</li>
                <li>SMS</li>
                <li>
                  Any other forms of communication by Minty CRM or its clients
                </li>
              </ul>
              End users of Minty CRM can opt out of selected or all forms of
              contact by Minty CRM or its clients.
            </div>
            <div class="text-content pb-3">
              We may also share the Personal Data collected by merchants to
              comply with applicable laws and regulations, to respond to a
              subpoena, search warrant or other lawful request for information
              we receive, to protect the integrity of this Site, or to otherwise
              protect our rights.
            </div>
            <div class="text-title pb-3">Retention of Personal Data</div>
            <div class="text-content pb-3">
              Merchants and us may retain your personal data for as long as it
              is necessary to fulfil the purpose for which it was collected, or
              as required or permitted by applicable laws.
            </div>
            <div class="text-title pb-3">Withdrawal of Personal Data</div>
            <div class="text-content pb-3">
              You may withdraw your consent to provide Personal Data by
              submitting your request to the merchant which you have provided
              your Personal Data to.
            </div>
            <div class="text-title pb-3">
              Access and Correction of Personal Data
            </div>
            <div class="text-content pb-3">
              You have the right to access and update your Personal Data at any
              time. If you would like to correct or review the Personal Data
              about you, do contact the merchant to make the necessary
              amendments.
            </div>
            <div class="text-title pb-3">Changes</div>
            <div class="text-content pb-3">
              We may review and update the necessary in this Privacy Policy from
              time to time in order to reflect, for example, changes to our
              practices or for other operational, legal or regulatory reasons.
            </div>
          </div>
        </div>
        <div v-else class="mbr-legal__empty" role="alert">
          <span class="mbr-legal__empty-icon" aria-hidden="true">
            <i class="material-icons-round">cloud_off</i>
          </span>
          <h2 class="mbr-legal__empty-title">{{ $t('legal.privacy_load_failed') }}</h2>
          <p class="mbr-legal__empty-sub">{{ $t('legal.check_connection') }}</p>
          <material-button class="mbr-legal__retry" @click="getTermsConditions()">{{ $t('legal.try_again') }}</material-button>
        </div>
      </div>
    </div>
    <material-loading :active="loaderActive" />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { useRoute } from "vue-router";
import { getMerchantCode } from "@/config/utils";
import HomeService from "../services/home.service";
import MaterialButton from "@/components/MaterialButton.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";

export default {
  name: "privacy-policy",
  components: {
    MaterialButton,
    MaterialLoading,
  },
  data() {
    return {
      isLoadDone: false,
      loadFailed: false,
      loaderActive: false,
      merchantCode: "",
      phone: "",
      branchCode: "",
      tableCode: "",
      from: "",
      privacyPolicy: "",
      // MBR130: default to the sign-in flow, the only entry point that wants a push to /sign-in
      cameFromSignIn: true,
    };
  },
  // MBR130: same fix as Terms (MBR104) — back used to always push /sign-in. Only the
  // sign-in / sign-up flow (and a direct URL hit, which has no history) still goes there.
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.cameFromSignIn = !from.name || from.name === "SignIn";
    });
  },
  created() {
    this.getTermsConditions();
  },
  beforeMount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  mounted() {
    const code = getMerchantCode();
    this.merchantCode = code ? `/${code}` : "";
    const route = useRoute();
    this.phone = route.query.phone ?? "";
    this.branchCode = route.query.branch_code ?? "";
    this.tableCode = route.query.table_code ?? "";
    this.from = route.query.from ?? "";
  },
  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),
    goBack() {
      if (this.cameFromSignIn) {
        this.backSignIn();
        return;
      }
      this.$router.back();
    },
    backSignIn() {
      this.$router.push({
        path: this.merchantCode + "/sign-in",
        query: {
          phone: this.phone,
          branch_code: this.branchCode,
          table_code: this.tableCode,
          from: this.from,
        },
      });
    },
    getTermsConditions() {
      this.loadFailed = false;
      this.showLoader();
      HomeService.getTermsConditions().then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.privacyPolicy = response.data.data.privacy_policy ?? "";
            this.isLoadDone = true;
          } else {
            this.loadFailed = true;
          }
          this.hideLoader();
        },
        () => {
          this.loadFailed = true;
          this.hideLoader();
        }
      );
    },
    showLoader() {
      this.loaderActive = true;
    },
    hideLoader() {
      this.loaderActive = false;
    },
  },
};
</script>
<style scoped>
.mbr-legal.page-header {
  flex-direction: column;
  /* custom.css `.min-vh-screen` reserves 56px for the bottom nav, which these pages don't have */
  min-height: 100vh !important;
  font-family: var(--mbr-font-body);
}

.mbr-legal .mask {
  background: var(--mbr-color-canvas) !important;
  opacity: 1;
}

.mbr-legal__bar {
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: 48px 1fr 48px;
  align-items: center;
  gap: 12px;
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding: 48px 20px 20px;
}

.mbr-legal__back {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  padding: 0;
  background: var(--mbr-color-surface);
  border: 1px solid var(--mbr-color-outline);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-ink-headline);
  box-shadow: var(--mbr-shadow-card);
  transition: transform 0.15s ease;
}

.mbr-legal__back:active {
  transform: scale(0.95);
}

.mbr-legal__back .material-icons-round {
  font-size: 26px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-legal__title {
  margin: 0;
  text-align: center;
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-headline-sm-size);
  font-weight: 800;
  line-height: var(--mbr-headline-sm-line);
  letter-spacing: 0.04em;
  color: var(--mbr-color-ink-headline);
}

.container.mbr-legal__page {
  position: relative;
  z-index: 1;
  max-width: 720px;
  padding: 0 20px;
}

/* !important outranks the p-0 / pb-90 utilities kept on the element */
.mbr-legal__page .card-body {
  margin-bottom: 40px;
  padding: 24px 20px !important;
  background: var(--mbr-color-card);
  border-radius: var(--mbr-radius-xl);
  box-shadow: var(--mbr-shadow-card);
}

.text-page {
  text-align: left;
  font-size: 14px;
  line-height: 22px;
  color: var(--mbr-color-ink-secondary);
  overflow-wrap: anywhere;
}

.text-title {
  margin-top: 8px;
  font-family: var(--mbr-font-headline);
  color: var(--mbr-color-ink-headline) !important;
  font-weight: 700 !important;
  font-size: 17px !important;
  line-height: 24px;
}

.text-title-2 {
  font-size: 16px !important;
  font-weight: 600;
  color: var(--mbr-color-ink-secondary);
}

.text-i {
  color: var(--mbr-color-ink-muted) !important;
  font-weight: 600 !important;
  font-size: 12px !important;
  letter-spacing: 0.04em;
}

.text-content {
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 22px;
  color: var(--mbr-color-ink-secondary);
}

.text-content-2 {
  color: var(--mbr-color-ink-headline) !important;
  font-weight: 600 !important;
  font-size: 14px !important;
}

.text-emphasize {
  color: var(--mbr-color-ink-headline) !important;
  font-weight: 600 !important;
}

.pb-90 {
  padding-bottom: 90px !important;
}

/* Merchant-authored HTML from get-terms-conditions */
.mbr-legal__html :deep(h1),
.mbr-legal__html :deep(h2),
.mbr-legal__html :deep(h3),
.mbr-legal__html :deep(h4),
.mbr-legal__html :deep(h5),
.mbr-legal__html :deep(h6) {
  margin: 16px 0 8px;
  font-family: var(--mbr-font-headline);
  font-size: 17px;
  font-weight: 700;
  line-height: 24px;
  color: var(--mbr-color-ink-headline);
}

.mbr-legal__html :deep(p) {
  margin: 0 0 12px;
}

.mbr-legal__html :deep(a) {
  color: var(--mbr-color-label);
  text-decoration: underline;
}

.mbr-legal__html :deep(img) {
  max-width: 100%;
  height: auto;
}

.mbr-legal__html :deep(ul),
.mbr-legal__html :deep(ol) {
  margin: 0 0 12px;
  padding-left: 20px;
}

.mbr-legal__html :deep(li) {
  margin-bottom: 4px;
}

.mbr-legal__html :deep(strong),
.mbr-legal__html :deep(b) {
  font-weight: 700;
  color: var(--mbr-color-ink-headline);
}

/* Wide merchant tables scroll inside the card instead of widening the page */
.mbr-legal__html :deep(table) {
  display: block;
  max-width: 100%;
  margin: 0 0 12px;
  overflow-x: auto;
  border-collapse: collapse;
}

/* overflow-wrap reset: .text-page's `anywhere` would split words so columns shrink instead of scrolling */
.mbr-legal__html :deep(th),
.mbr-legal__html :deep(td) {
  padding: 8px 10px;
  border: 1px solid var(--mbr-color-outline);
  text-align: left;
  vertical-align: top;
  overflow-wrap: normal;
}

.mbr-legal__html :deep(th) {
  background: var(--mbr-color-tint);
  font-weight: 700;
  color: var(--mbr-color-ink-headline);
}

/* get-terms-conditions failed */
.mbr-legal__empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 24px 4px;
  text-align: center;
}

.mbr-legal__empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  margin-bottom: 8px;
  background: var(--mbr-color-tint);
  border-radius: var(--mbr-radius-full);
  color: var(--mbr-color-primary);
}

.mbr-legal__empty-icon .material-icons-round {
  font-size: 32px;
}

/* font-family/color set explicitly: Material Dashboard forces Roboto Slab on h1-h3 */
.mbr-legal__empty-title {
  margin: 0;
  font-family: var(--mbr-font-headline);
  font-size: var(--mbr-headline-sm-size);
  font-weight: 700;
  line-height: var(--mbr-headline-sm-line);
  color: var(--mbr-color-ink-headline);
}

.mbr-legal__empty-sub {
  margin: 0;
  font-size: 14px;
  line-height: 20px;
  color: var(--mbr-color-ink-muted);
}

.mbr-legal__retry {
  min-width: 160px;
  margin-top: 12px;
}
</style>
